/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */


import {gql} from "urql";
import {ListResponse, EventSubscription} from "../../interfaces/Global";

export const EventSubscriptionsQuery = gql`
    query EventSubscriptions($createdBy: String, $idIn: [ID!], $enabled: Boolean, $orderBy: String, $offset: Int, $limit: Int) {
        eventSubscriptions(createdBy: $createdBy, idIn: $idIn, enabled: $enabled, orderBy: $orderBy, offset: $offset, limit: $limit) {
            total
            items {
                id
                createdBy
                creationDate
                modifiedBy
                modifiedDate
                vstamp
                enabled
                config
	            lastTriggered
	            triggerCount
            }
        }
    }
`;

export interface EventSubscriptionsResponse {
	eventSubscriptions: ListResponse<EventSubscription>
}

export interface EventSubscriptionsQueryVars {
	createdBy?: string
	enabled?: boolean
	orderBy?: string
	limit?: number
	offset?: number
}

export const EventSubscriptionQuery = gql`
    query EventSubscription($id: ID!) {
        eventSubscription(id: $id) {
            id
            createdBy
            creationDate
            modifiedBy
            modifiedDate
            vstamp
            enabled
            config
            lastTriggered
            triggerCount
        }
    }
`;

export interface EventSubscriptionResponse {
	eventSubscription: EventSubscription
}

export interface EventSubscriptionQueryVars {
	id: number
}